import React from "react";
import ReactDOM from "react-dom";
import AppProvider from "Providers/AppProvider";
import { color } from "Configs/theme";
import { hackShadowRoot } from "Helpers/ShadowRootHelper";

export default class ExternalChat extends HTMLElement {
  mountPoint: HTMLDivElement;
  isStandaloneApp: boolean;
  userToken: string | null;
  organizationIdForAppInit: string | null;


  constructor() {
    super();
    this.mountPoint = document.createElement("div");
    this.mountPoint.style.flexDirection = "column";
    this.mountPoint.style.display = "flex";
    this.mountPoint.style.flex = "1";
    this.mountPoint.style.backgroundColor = color.card;
    this.isStandaloneApp = this.hasAttribute("is-standalone-app");
    this.userToken = this.getAttribute("user-token");
    this.organizationIdForAppInit = this.getAttribute("organization-id-for-app-init")

    if (!this.isStandaloneApp) {
      this.mountPoint.style.overflowX = "hidden";
      this.mountPoint.style.overflowY = "scroll";
    }
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "open" });
    const reactRoot = shadowRoot.appendChild(this.mountPoint);
    this.userToken = this.getAttribute("user-token");

    hackShadowRoot(this.mountPoint, shadowRoot);
    ReactDOM.render(
      <AppProvider
        shadowRoot={shadowRoot}
        reactRoot={reactRoot}
        mountPoint={this.mountPoint}
        isStandaloneApp={this.isStandaloneApp}
        token={this.userToken}
        organizationIdForAppInit={this.organizationIdForAppInit}

      />,
      this.mountPoint
    );
  }

  disconnectedCallback() {
    if (this.mountPoint) {
      ReactDOM.unmountComponentAtNode(this.mountPoint);
    }
  }
}

window.customElements.define("external-chat", ExternalChat);
